import React from 'react'
import styled from 'styled-components'
import EmojiSelect from 'Event/Dashboard/components/EmojiList/EmojiSelect'
import EmojiUpload from 'Event/Dashboard/components/EmojiList/EmojiUpload'
import {
  DEFAULT_EMOJIS,
  createCustomEmoji,
  Emoji,
} from 'Event/Dashboard/components/EmojiList/emoji'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from 'lib/ui/IconButton'
import Label from 'lib/ui/TextField/Label'
import TextField from 'lib/ui/TextField'
import {useTownhallTemplate} from 'Event/template/Townhall'
import {useConfig} from 'organization/Event/Configurable'
import {useAttendeeVariables} from 'Event'

export default function Settings(props: {
  emojis: string[]
  setEmojis: (newEmojis: string[]) => void
  addCustomEmoji: (emojiName: Emoji['name']) => void
  removeCustomEmoji: (emojiName: Emoji['name']) => void
  customEmojis: Emoji['name'][]
}) {
  const {
    emojis,
    setEmojis,
    addCustomEmoji,
    removeCustomEmoji,
    customEmojis,
  } = props

  const {
    form: {register},
  } = useConfig()

  const template = useTownhallTemplate()
  const v = useAttendeeVariables()

  const customEmojisWithImage = customEmojis.map(createCustomEmoji)
  const availableEmojis = [...DEFAULT_EMOJIS, ...customEmojisWithImage]

  const addNewEmoji = (emoji: Emoji['name']) => {
    const added = [...emojis, emoji]
    setEmojis(added)
  }

  const updateEmoji = (index: number) => (target: Emoji['name']) => {
    const updated = emojis.map((e, i) => {
      const isTarget = i === index
      if (isTarget) {
        return target
      }

      return e
    })

    setEmojis(updated)
  }

  const remove = (index: number) => () => {
    const removed = emojis.filter((e, i) => i !== index)
    setEmojis(removed)
  }

  return (
    <>
      <Label>Main Menu Item Title</Label>
      <TextField
        name="navBar.mainMenuItemTitle"
        defaultValue={v(template.navBar.mainMenuItemTitle)}
        aria-label="update main menu item title"
        fullWidth
        inputProps={{
          ref: register,
        }}
      />

      <h3>Emojies</h3>
      <ExistingEmojiesHolder>
        {emojis.map((emoji, index) => (
          <ExistingEmoji key={index}>
            <EmojiSelect
              emojis={availableEmojis}
              value={emoji}
              onPick={updateEmoji(index)}
              label=""
            />
            <RemoveButton aria-label="remove emoji" onClick={remove(index)}>
              <CloseIcon color="error" />
            </RemoveButton>
          </ExistingEmoji>
        ))}
      </ExistingEmojiesHolder>
      <EmojiSelect
        value=""
        emojis={availableEmojis}
        onPick={addNewEmoji}
        label="Add Emoji"
      />

      <h3>Custom Emojies</h3>

      <EmojiUpload onSuccess={addCustomEmoji} />

      <CustomEmojiList>
        {customEmojis.map((emoji, index) => (
          <CustomEmojiItem key={index}>
            <Image src={createCustomEmoji(emoji).image} alt={emoji} />
            <RemoveCustomEmojiButton
              aria-label="remove custom emoji"
              onClick={() => {
                removeCustomEmoji(emoji)
              }}
            >
              <CloseIcon color="error" />
            </RemoveCustomEmojiButton>
          </CustomEmojiItem>
        ))}

        {customEmojis.length === 0 && <p>No custom emojies</p>}
      </CustomEmojiList>
    </>
  )
}

const CustomEmojiList = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
`

const CustomEmojiItem = styled.div`
  display: flex;
  background: #ffffff;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
`

const ExistingEmoji = styled.div`
  display: flex;
  align-items: center;
  width: 31%;
`

const ExistingEmojiesHolder = styled.div`
  display: flex;
  gap: 3.33%;
  flex-wrap: wrap;
`

const RemoveButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.spacing[2]};
  margin-top: -${(props) => props.theme.spacing[10]};
`

const RemoveCustomEmojiButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.spacing[2]};
`
const Image = styled.img`
  width: 30px;
`
